import { KenoDataServiceAPI } from '@API/gambyt-data-services/keno-api'

export const fetchGameConfig = async () => {
  try {
    const result = await KenoDataServiceAPI.fetchKenoConfiguration()
    return result
  } catch (e) {
    console.error(`Error: Game Data Service API / Fetch Game Config / ${e}`)
    throw e
  }
}

export const KenoConfigurationAPI = {
  fetchGameConfig,
}
